import { Modal } from "../../../../components/modal.jsx";
import { Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { addDays, differenceInCalendarDays } from "date-fns";

export function FreeTrialModal() {
  let session = useSelector((state) => state.session);
  let location = useLocation();
  let ui = useSelector((state) => state.ui);

  let daysRemaining = differenceInCalendarDays(
    addDays(new Date(session?.account?.when), 30),
    new Date()
  );
  let expired =
    session?.account?.billingPlan === "free" &&
    location.pathname !== "/help" &&
    daysRemaining <= 0;

  expired = false;

  if (!expired) return <></>;

  return (
    <Modal>
      <div className={"flex flex-col gap-3 text-center"}>
        <div style={{ fontSize: 50 }}>⌛</div>
        <div>Your free trial has finished.</div>
        <div>
          To continue using the application, please{" "}
          <Link to={"/settings/help"} className={"underline"}>
            contact us
          </Link>
        </div>
      </div>
    </Modal>
  );
}
